import { useEffect, useState } from "react"
import * as authService from "../services/auth-service"
import { City } from "./models/City"
import { County } from "./models/County"

// Localitatile unui judet nu se schimba intre sesiuni, asa ca le tinem cat traieste
// tab-ul. Fara asta, modalul si pagina care il deschide ar cere aceeasi lista de doua ori.
const cityCache = new Map<string, Array<City>>()
const inFlight = new Map<string, Promise<Array<City>>>()

export const fetchCitiesByCounty = (countyCode: string): Promise<Array<City>> => {
    const cached = cityCache.get(countyCode)
    if (cached) return Promise.resolve(cached)

    const pending = inFlight.get(countyCode)
    if (pending) return pending

    const request = authService.getCitiesByCounty(countyCode)
        .then((data: Array<City>) => {
            cityCache.set(countyCode, data)
            inFlight.delete(countyCode)
            return data
        })
        .catch((error) => {
            inFlight.delete(countyCode)
            throw error
        })

    inFlight.set(countyCode, request)
    return request
}

export const useCounties = () => {
    const [counties, setCounties] = useState<Array<County>>([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        authService.getCounties()
            .then((data: Array<County>) => setCounties(data))
            .catch(() => setCounties([]))
            .finally(() => setIsLoading(false))
    }, [])

    return { counties, isLoading }
}

export const useCitiesByCounty = (countyCode: string) => {
    const [cities, setCities] = useState<Array<City>>([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (!countyCode) {
            setCities([])
            return
        }

        let active = true
        setIsLoading(true)

        fetchCitiesByCounty(countyCode)
            .then((data) => { if (active) setCities(data) })
            .catch(() => { if (active) setCities([]) })
            .finally(() => { if (active) setIsLoading(false) })

        // Judetul se poate schimba inainte sa raspunda cererea anterioara; fara asta
        // raspunsul vechi ar suprascrie lista celui nou selectat.
        return () => { active = false }
    }, [countyCode])

    return { cities, isLoading }
}
